<template>
  <div class="fail" :style="cssProps()"></div>
</template>

<script>
import { color } from "d3-color";

export default {
  name: "Coil",
  props: ["protein", "acid", "color"],
  methods: {
    cssProps() {
      return {
        "--protein-color": this.color,
        "--hover-color": color(this.color).brighter(1.2)
      };
    }
  }
};
</script>

<style scoped>
.fail {
  flex: 1 1 0;
  background: gray;
  height: 6px;
  display: flex;
  align-items: center;
  border-top: 7px;
  border-bottom: 7px;
  border-left: 0px;
  border-right: 0px;
  border-style: solid;
  border-color: transparent;
  background-clip: padding-box;

}
.fail:hover {
  background: darkgray;
  background-clip: padding-box;

}

</style>